module.exports = __webpack_public_path__ + "img/pnu_gallery0.c58c58ca.jpg";